export const OTP_LENGTH = 6;
export enum CHANNEL_OTP {
  EMAIL = 'CHANNEL_EMAIL',
  SMS = 'CHANNEL_SMS',
  WHATSAPP = 'CHANNEL_WHATSAPP',
}
